export default "__VITE_ASSET__rTN3wbNV__"